export enum SharedWorkflowStateValue {
  ApprovalRequired = "approval_required",
  Approved = "approved",
  Blocked = "blocked",
  Executed = "executed"
}

export enum SharedPolicyClassValue {
  SafeRead = "safe_read"
}
